import InterfaceCatatanEdukasi from "../apiInterface/InterfaceCatatanEdukasi";
import ErrorAlert from "@/utility/ErrorAlert";

class DataCatatanEdukasi {
   async getDataCatatanEdukasi(reg) {
    // let dt: object = {}
    let dt: any;
    await InterfaceCatatanEdukasi.getCatatanEdukasi(reg)
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response
          ErrorAlert.showSnackAlert(e, "Catatan Edukasi")
      });
    return dt;
  }

  async saveDataCatatanEdukasi(
    reg, rm, param
  ) {
    let dt: object = {};
    await InterfaceCatatanEdukasi.saveCatatanEdukasi(
      reg, rm, param
    )
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response;
        ErrorAlert.showErrorAlert(e);
      });
    return dt;
  }

  async editDataCatatanEdukasi(
    id, reg, rm, param
  ) {
    let dt: object = {};
    await InterfaceCatatanEdukasi.editCatatanEdukasi(
      id, reg, rm, param
    )
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response;
        ErrorAlert.showErrorAlert(e);
      });
    return dt;
  }
}

export default new DataCatatanEdukasi();
